import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';

var render = function render(){var _vm=this,_c=_vm._self._c;return _c(VRow,{attrs:{"align":"center","dense":""}},[_c(VCol,{attrs:{"cols":"auto"}},[_c('tcn-file-icon',{attrs:{"width":"30","file-name":_vm.file.name,"left":""}})],1),_c(VCol,{staticClass:"user-details",staticStyle:{"display":"inline-flex","align-items":"center"},attrs:{"cols":"auto"}},[_c('span',{staticClass:"font-weight-bold"},[_vm._v(_vm._s(_vm.file.name))])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }